import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

function AppLoginSuccess() {
    return (
        <Box p={4}>
            <Heading>Success!</Heading>
            <p>You were logged in successfully, go back to your CLI.</p>
        </Box>
    );
}

export default AppLoginSuccess;

